document.addEventListener('DOMContentLoaded', function () {

  console.log('_hallo recall');

  const select = document.querySelector('select[name="privat-oder-geschaeftlich"]');
  const firmaInput = document.querySelector('input[name="firma"]');

  if (!select || !firmaInput) return;

  const toggleFirma = () => {
    if (select.value === 'Geschäftskunde') {
      firmaInput.classList.remove('js-hidden');
      firmaInput.disabled = false; 
    } else {
      firmaInput.classList.add('js-hidden');
      firmaInput.disabled = true; 
    }
  };

  // 🟡 Beim Laden erstmal deaktivieren
  firmaInput.disabled = true;

  // Initial prüfen
  toggleFirma();

  // Reaktion bei Änderung
  select.addEventListener('change', toggleFirma);
});
